import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import SearchableDropdown from "../../Components/SearchableDropdown";

function MergeProject(props) {
    const [user] = useContext(AuthContext);
    const [target, setTarget] = useState(null);
    const [projects, setProjects] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        fetch(`/api/project/${props.add}/merge_to/${target.key}`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err)
            })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='MergeProject'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setTarget(null);
        const abortController = new AbortController();
        async function fetchList() {
            await fetch(`/api/project`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setProjects(data.filter((item) => item.id !== parseInt(props.add)).map((item) => ({
                        'key': item.id,
                        'text': `${item.project} (${item.venture} - ${item.account})`
                    })));
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchList();
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Połącz Projekt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='MergeProject'>
                <SearchableDropdown
                    label="Dołącz do"
                    selectedKey={target ? target.key : undefined}
                    onChange={(e, item) => setTarget(item)}
                    placeholder="Wybierz z listy"
                    options={projects}
                />
            </form>
        </Panel>
    )
}

export default MergeProject;